var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_26026)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 18.6875C10.6605 18.6875 9.84975 18.5897 9.07062 18.4237L5.68675 20.4578L5.73204 17.1235C3.13807 15.5638 1.4375 12.9849 1.4375 10.0625C1.4375 5.29934 5.94263 1.4375 11.5 1.4375C17.0574 1.4375 21.5625 5.29934 21.5625 10.0625C21.5625 14.8264 17.0574 18.6875 11.5 18.6875ZM11.5 0C5.14912 0 0 4.50584 0 10.0625C0 13.2387 1.68547 16.0669 4.3125 17.9105V23L9.35022 19.9432C10.0474 20.0582 10.7647 20.125 11.5 20.125C17.8509 20.125 23 15.6199 23 10.0625C23 4.50584 17.8509 0 11.5 0ZM16.5312 7.90625H6.46875C6.072 7.90625 5.75 8.22825 5.75 8.625C5.75 9.02247 6.072 9.34375 6.46875 9.34375H16.5312C16.928 9.34375 17.25 9.02247 17.25 8.625C17.25 8.22825 16.928 7.90625 16.5312 7.90625ZM15.0938 12.2188H7.90625C7.5095 12.2188 7.1875 12.54 7.1875 12.9375C7.1875 13.335 7.5095 13.6562 7.90625 13.6562H15.0938C15.4905 13.6562 15.8125 13.335 15.8125 12.9375C15.8125 12.54 15.4905 12.2188 15.0938 12.2188Z",
    fill: "#373A42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_26026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.542e892e232e38bb765c76fe8c1bb913.svg";
export { ForwardRef as ReactComponent };